import React, { type ReactNode } from 'react';
import { type MapStateToProps, connect } from 'react-redux';
import { Sticky } from 'react-sticky';

import styles from '../../../../sass/definitions/_breakpoints.scss';
import * as D from '../../deps';
import { isBackstageRightRailActive } from '../../utils';

import './BackstageLargeHeaderStickySidebar.scss';

interface IBackstageLargeHeaderStickySidebarStateProps {
  isRightRailActive: boolean;
  useStickySidebar: boolean;
}

interface IBackstageLargeHeaderStickySidebarOwnProps {
  children: ReactNode | ReactNode[];
}

type IBackstageLargeHeaderStickySidebarProps = IBackstageLargeHeaderStickySidebarStateProps &
  IBackstageLargeHeaderStickySidebarOwnProps;

const BackstageLargeHeaderStickySidebar: React.FC<
  IBackstageLargeHeaderStickySidebarProps
> = props => {
  const { useStickySidebar, isRightRailActive, children } = props;

  const classNames = D.createBEM('BackstageLargeHeaderStickySidebar', {
    rightRail: isRightRailActive,
  });

  const SidebarContent = <div className={classNames}>{children}</div>;

  return useStickySidebar ? (
    <Sticky topOffset={-105} stickyStyle={{ top: '105px' }}>
      {/* @ts-expect-error TS(2322) FIXME: Type 'Element' is not assignable to type '((args: ... Remove this comment to see the full error message */}
      {SidebarContent}
    </Sticky>
  ) : (
    SidebarContent
  );
};

export const mapStateToProps: MapStateToProps<
  IBackstageLargeHeaderStickySidebarStateProps,
  IBackstageLargeHeaderStickySidebarOwnProps
> = (state: $TSFixMe) => {
  const { width, height } = D.getViewportDimensions();
  const isBreakWidth = width <= parseInt(styles.BREAK_WIDTH_XS, 10);
  const isBreakHeight = height <= parseInt(styles.BREAK_HEIGHT_XXSM, 10);
  const isMobileView = isBreakWidth || isBreakHeight;

  return {
    isRightRailActive: isBackstageRightRailActive(state),
    useStickySidebar: !isMobileView,
  };
};

export default connect(mapStateToProps)(BackstageLargeHeaderStickySidebar);
